// @ts-nocheck 06d4397d
import * as addPanel from '#packages/oldAddPanel';

export default {
  getCategorySections() {
    return addPanel.sections.getSections().repeater;
  },
};
